import React, { useState, useEffect, useMemo, useRef } from 'react';
import { FaStar, FaUser, FaChevronLeft, FaChevronRight } from 'react-icons/fa';
import { useDispatch, useSelector } from 'react-redux'
import { StarRatingWeb } from '../../redux/slice/StarRatingWeb';
import '../../assets/css/Reviews.css';

const Reviews = () => {
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [newReview, setNewReview] = useState('');
  const [newRating, setNewRating] = useState(0);
  const [currentSlide, setCurrentSlide] = useState(1);
  const [cardsPerSlide, setCardsPerSlide] = useState(3);
  const [isAnimating, setIsAnimating] = useState(true);
  const [dragOffset, setDragOffset] = useState(0);
  const [isDragging, setIsDragging] = useState(false);
  const dragRef = useRef({
    isDragging: false,
    startX: 0,
    offset: 0,
    moved: false,
  });
  const viewportRef = useRef(null);
  const dispatch = useDispatch()
  const reviews = useSelector(state => state?.starRatingWeb?.data) || []
  // const [reviews, setReviews] = useState([
  //   {
  //     id: 1,
  //     user: 'John Doe',
  //     rating: 5,
  //     review: 'Excellent service! Fast and reliable link shortening.',
  //     date: '2024-01-15'
  //   },
  //   {
  //     id: 2,
  //     user: 'Sarah Wilson',
  //     rating: 4,
  //     review: 'Great analytics dashboard. Very user-friendly interface.',
  //     date: '2024-01-14'
  //   },
  //   {
  //     id: 3,
  //     user: 'Mike Johnson',
  //     rating: 5,
  //     review: 'Perfect for my business needs. Highly recommended!',
  //     date: '2024-01-13'
  //   },
  //   {
  //     id: 4,
  //     user: 'Emily Brown',
  //     rating: 4,
  //     review: 'Love the custom domain feature. Makes branding easy.',
  //     date: '2024-01-12'
  //   },
  //   {
  //     id: 5,
  //     user: 'David Lee',
  //     rating: 5,
  //     review: 'Outstanding customer support and fast response times.',
  //     date: '2024-01-11'
  //   }
  // ]);
  console.log(reviews)

  useEffect(() => {
    dispatch(StarRatingWeb())
  }, [])

  useEffect(() => {
    const updateCardsPerSlide = () => {
      setCardsPerSlide(window.innerWidth <= 768 ? 1 : 3);
    };

    updateCardsPerSlide();
    window.addEventListener('resize', updateCardsPerSlide);
    return () => window.removeEventListener('resize', updateCardsPerSlide);
  }, []);

  const reviewSlides = useMemo(() => {
    const slides = [];
    for (let i = 0; i < reviews.length; i += cardsPerSlide) {
      slides.push(reviews.slice(i, i + cardsPerSlide));
    }
    return slides;
  }, [reviews, cardsPerSlide]);

  const canLoop = reviewSlides.length > 1;
  const loopSlides = useMemo(() => {
    if (!canLoop) return reviewSlides;
    return [reviewSlides[reviewSlides.length - 1], ...reviewSlides, reviewSlides[0]];
  }, [reviewSlides, canLoop]);

  useEffect(() => {
    setIsAnimating(false);
    setCurrentSlide(canLoop ? 1 : 0);
    setDragOffset(0);
  }, [cardsPerSlide, reviews.length, canLoop]);

  const goToSlide = (index) => {
    if (!canLoop) {
      setCurrentSlide(Math.max(0, Math.min(index, reviewSlides.length - 1)));
      return;
    }
    setIsAnimating(true);
    setCurrentSlide(index);
  };

  const goToPrevSlide = () => {
    if (!reviewSlides.length) return;
    goToSlide(currentSlide - 1);
  };

  const goToNextSlide = () => {
    if (!reviewSlides.length) return;
    goToSlide(currentSlide + 1);
  };

  const handleTransitionEnd = () => {
    if (!canLoop) return;
    if (currentSlide === 0) {
      setIsAnimating(false);
      setCurrentSlide(reviewSlides.length);
    } else if (currentSlide === reviewSlides.length + 1) {
      setIsAnimating(false);
      setCurrentSlide(1);
    }
  };

  const activeDot = canLoop
    ? (currentSlide - 1 + reviewSlides.length) % reviewSlides.length
    : currentSlide;

  const getPointerX = (event) => event.clientX ?? event.touches?.[0]?.clientX ?? 0;

  const handlePointerDown = (event) => {
    if (!canLoop) return;
    dragRef.current = {
      isDragging: true,
      startX: getPointerX(event),
      offset: 0,
      moved: false,
    };
    setIsDragging(true);
    setIsAnimating(false);
    viewportRef.current?.setPointerCapture?.(event.pointerId);
  };

  const handlePointerMove = (event) => {
    if (!dragRef.current.isDragging) return;
    const offset = getPointerX(event) - dragRef.current.startX;
    dragRef.current.offset = offset;
    if (Math.abs(offset) > 8) dragRef.current.moved = true;
    setDragOffset(offset);
  };

  const handlePointerUp = () => {
    if (!dragRef.current.isDragging) return;
    const offset = dragRef.current.offset;
    const width = viewportRef.current?.offsetWidth || 1;
    dragRef.current.isDragging = false;
    setIsDragging(false);
    setDragOffset(0);
    setIsAnimating(true);

    if (Math.abs(offset) > width * 0.18) {
      if (offset < 0) goToNextSlide();
      else goToPrevSlide();
    }
  };


  const handleSubmitReview = (e) => {
    e.preventDefault();
    if (newReview.length > 50) {
      alert('Review must be 50 characters or less');
      return;
    }
    if (newRating === 0) {
      alert('Please select a rating');
      return;
    }

    const review = {
      id: reviews.length + 1,
      user: 'Current User',
      rating: newRating,
      review: newReview,
      date: new Date().toISOString().split('T')[0]
    };

    // setReviews([review, ...reviews]);
    setNewReview('');
    setNewRating(0);
  };

  const renderStars = (rating) => {
    return Array.from({ length: 5 }, (_, index) => (
      <FaStar
        key={index}
        className={`star ${index < rating ? 'filled' : 'empty'}`}
      />
    ));
  };

  const renderRatingInput = () => {
    return Array.from({ length: 5 }, (_, index) => (
      <FaStar
        key={index}
        className={`rating-star ${index < newRating ? 'selected' : ''}`}
        onClick={() => setNewRating(index + 1)}
      />
    ));
  };

  return (
    <section className="reviews-section">
      <div className="container">
        <h2 data-aos="flip-down">What Our Users Say</h2>

        {/* Login Status */}
        {/* <div className="login-status" data-aos="slide-right" data-aos-delay="200">
          {isLoggedIn ? (
            <div className="logged-in">
              <FaUser className="user-icon" />
              <span>Welcome back! You can leave a review.</span>
            </div>
          ) : (
            <div className="not-logged-in">
              <FaLock className="lock-icon" />
              <span>Please log in to leave a review</span>
              <button 
                className="login-btn"
                onClick={() => setIsLoggedIn(true)}
              >
                Login
              </button>
            </div>
          )}
        </div> */}

        {/* Review Form */}
        {/* {isLoggedIn && (
          <div className="review-form-container" data-aos="slide-left" data-aos-delay="400">
            <h3>Leave a Review</h3>
            <form onSubmit={handleSubmitReview} className="review-form">
              <div className="rating-input">
                <label>Rating:</label>
                <div className="stars-input">
                  {renderRatingInput()}
                </div>
              </div>
              
              <div className="review-input">
                <label htmlFor="review">Review (max 50 characters):</label>
                <textarea
                  id="review"
                  value={newReview}
                  onChange={(e) => setNewReview(e.target.value)}
                  maxLength={50}
                  placeholder="Share your experience..."
                  rows={3}
                />
                <div className="char-count">
                  {newReview.length}/50 characters
                </div>
              </div>
              
              <button type="submit" className="submit-review-btn">
                Submit Review
              </button>
            </form>
          </div>
        )} */}

        {/* Reviews Slider */}
        {reviewSlides.length > 0 && (
          <div className="reviews-slider">
            <button
              type="button"
              className="reviews-slider-btn"
              onClick={goToPrevSlide}
              aria-label="Previous reviews"
            >
              <FaChevronLeft />
            </button>

            <div
              className="reviews-slider-viewport"
              ref={viewportRef}
              onPointerDown={handlePointerDown}
              onPointerMove={handlePointerMove}
              onPointerUp={handlePointerUp}
              onPointerCancel={handlePointerUp}
            >
              <div
                className={`reviews-slider-track ${isAnimating ? 'is-animating' : ''} ${isDragging ? 'is-dragging' : ''}`}
                style={{ transform: `translateX(calc(-${currentSlide * 100}% + ${dragOffset}px))` }}
                onTransitionEnd={handleTransitionEnd}
              >
                {loopSlides.map((slideReviews, slideIndex) => (
                  <div key={slideIndex} className="reviews-slide">
                    <div className={`reviews-slide-grid cards-${cardsPerSlide}`}>
                      {slideReviews.map((review, index) => (
                        <div
                          key={review.id || review._id || `${slideIndex}-${index}`}
                          className="review-card"
                        >
                          <div className="review-header">
                            <div className="user-info">
                              <FaUser className="user-avatar" />
                              <span className="username">{review.name}</span>
                            </div>
                            <div className="review-date">{new Date(review.date).toLocaleDateString('en-GB')}</div>
                          </div>

                          <div className="review-rating">
                            {renderStars(review.rating)}
                          </div>

                          <div className="review-text">
                            "{review.description}"
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>
                ))}
              </div>
            </div>

            <button
              type="button"
              className="reviews-slider-btn"
              onClick={goToNextSlide}
              aria-label="Next reviews"
            >
              <FaChevronRight />
            </button>
          </div>
        )}

        {reviewSlides.length > 1 && (
          <div className="reviews-slider-dots">
            {reviewSlides.map((_, index) => (
              <button
                key={index}
                type="button"
                className={`reviews-slider-dot ${activeDot === index ? 'active' : ''}`}
                onClick={() => goToSlide(canLoop ? index + 1 : index)}
                aria-label={`Go to slide ${index + 1}`}
              />
            ))}
          </div>
        )}

        {/* Average Rating */}
        {/* <div className="average-rating" data-aos="bounce-in" data-aos-delay="1200">
          <h3>Average Rating</h3>
          <div className="avg-rating-display">
            <div className="avg-number">
              {(reviews.reduce((sum, review) => sum + review.rating, 0) / reviews.length).toFixed(1)}
            </div>
            <div className="avg-stars">
              {renderStars(Math.round(reviews.reduce((sum, review) => sum + review.rating, 0) / reviews.length))}
            </div>
            <div className="avg-text">
              Based on {reviews.length} reviews
            </div>
          </div>
        </div> */}
      </div>
    </section>
  );
};

export default Reviews;
